import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { isFormSubmitted } from "../../../common/utilities/FormsHelper";
import { MerchantApi } from "../../../common/apis/merchant-api";
import { InputType } from "../../../common/components/input/enum/InputType";
import { ErrorHandling } from "../../../common/classes/ErrorHandling";
import { validatePassword } from "../../../common/utilities/CustomValidator";
import { AppNavigator, NavigatorTarget } from "../../../services/app-navigator";
import { ActivatedRoute } from "@angular/router";
import { ValidationErrorType } from "../../../common/enums/ValidationErrorType";
import { MerchantLoginService } from "../../../common/services/merchant-login.service";
import {BaseApiService} from "../../../common/services/base-api-service";

@Component({
  selector: 'app-create-new-password',
  templateUrl: './merchant-create-new-password.component.html',
  styleUrls: ['./merchant-create-new-password.component.scss']
})
export class MerchantCreateNewPasswordComponent {
  public showPasswordFieldText = false;
  public form: FormGroup = new FormGroup({});

  serverError: string | null = null
  isLoading = false;

  errorHandling: ErrorHandling | null = null;

  InputType = InputType;
  Validators = Validators
  validatePassword = validatePassword
  inputConfirmPassword = ''
  inputPassword = ''

  token = ''

  passwordLabel: string = $localize`:@@passwordLabel:Password`;
  confirmPasswordLabel: string = $localize`:@@confirmPassword:Confirm Password`;
  loginLabel: string = $localize`:@@loginLabel:Login`;


  constructor(private formBuilder: FormBuilder,
              private merchantApi: MerchantApi,
              private appNavigator: AppNavigator,
              private route: ActivatedRoute,
              private merchantLoginService: MerchantLoginService,
              protected readonly apiClient: BaseApiService) {
  }

  ngOnInit() {
    // this.token = this.route.snapshot.params['token'];
  }

  togglePasswordShowButtonClicked() {
    this.showPasswordFieldText = !this.showPasswordFieldText;
  }


  updateInputFieldById(id: string, value: any) {
    this.serverError = ""
    if (id == "password") {
      this.inputPassword = value;
    } else if (id == "confirmPassword") {
      this.inputConfirmPassword = value;
    }
  }

  matchPasswords(): boolean {
    let password = this.inputPassword
    let confirmPassword = this.inputConfirmPassword
    if (!password || !confirmPassword) {
      return false;
    }

    if (password !== confirmPassword) {
      return false
    }
    return true;
  }


  onUpdateSubmitted() {
    if (isFormSubmitted(this.form)) {
      if (!this.matchPasswords()) {
        this.serverError = $localize`:@@passWordNotMach:Passwords don't match.`;
        return;
      }
      this.isLoading = true;
      if (this.token?.hasActualValue()) {
        this.changePasswordWithToken()
      } else {
        this.changePassword()
      }
    }
  }

  redirectToLogin(): void {
    this.appNavigator.navigateTo({ target: NavigatorTarget.merchantLogin })
  }

  private changePasswordWithToken() {
    let token = this.token
    let password = this.inputPassword;
    this.merchantApi.merchantUpdateForgetPassword(token, password).subscribe({
      next: (result) => {
        this.isLoading = false;
        this.redirectToMerchantPortal()
      },
      error: error => {
        console.log(error)
        this.isLoading = false;
      }
    })

  }

  private changePassword() {
    let password = this.inputPassword;
    this.merchantApi.merchantChangePassword(password).subscribe({
      next: (result) => {
        this.isLoading = false;
        this.redirectToMerchantPortal()
      },
      error: error => {
        console.log(error)
        if (error === ValidationErrorType.UNAUTHORIZED) {
          this.redirectToLogin();
        }
        this.isLoading = false;
      }
    })
  }

  redirectToMerchantPortal() {
    console.log("redirectToMerchantPortal")
    if(this.apiClient.getJwt())
    {
      console.log("JWT exists")
      this.apiClient.getJwt()!.user.forceChangePassword = false
      this.merchantLoginService.redirectToLogin(this.apiClient.getJwt())
    }
    else {
      console.log("JWT doesn't exists")
      this.redirectToLogin();
    }
  }

  // redirectToMerchantPortal($token: string) {
  //   if(this)
  //   let email = this.inputEmail;
  //   let password = this.inputPassword;
  //   this.isLoading = true;
  //   this.merchantApi.merchantLogin(email, password).subscribe({
  //     next: (result) => {
  //       console.log("Logged in successfully")
  //       this.merchantLoginService.redirectToLogin($token);
  //       this.isLoading = false;
  //     },
  //     error: error => {
  //       this.isLoading = false;
  //       if(error == ValidationErrorType.emailNotVerified){
  //         this.navigateToVerifyEmail();
  //       } else {
  //         this.serverError = error
  //       }
  //     }
  //   })
  // }
}
